import React from 'react';
import { motion } from 'framer-motion';
import img from '../../Assets/jumbotron.webp';
import styles from './Intro.module.css';

function Intro() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.2, delayChildren: 0.1 } }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 10 } }
  };

  const imageVariants = {
    hidden: { scale: 0.8, opacity: 0, rotate: -2 },
    visible: { scale: 1, opacity: 1, rotate: 0, transition: { type: 'spring', stiffness: 50, damping: 20, delay: 0.4 } }
  };

  return (
    <div className={styles.heroContainer} id='GoToHome'>

      {/* Dynamic Background Elements */}
      <div className={styles.bgBlob1}></div>
      <div className={styles.bgBlob2}></div>
      <div className={styles.bgGrid}></div>

      <div className={styles.heroContentWrapper}>

        {/* Left Side: Text and CTA */}
        <motion.div
          className={styles.heroTextSection}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={itemVariants} className={styles.badge}>
            Transform Your Mind & Body
          </motion.div>

          <motion.h1 variants={itemVariants} className={styles.mainTitle}>
            Elevate Your <br />
            <span className={styles.highlightText}>Wellness Journey</span>
          </motion.h1>

          <motion.p variants={itemVariants} className={styles.subText}>
            Join our premium studio for expert-led yoga classes. Build strength, enhance flexibility, and find your inner balance in a modern, welcoming environment.
          </motion.p>

          <motion.div variants={itemVariants} className={styles.ctaGroup}>
            <button
              onClick={() => document.getElementById('GoToAboutUs')?.scrollIntoView({ behavior: 'smooth' })}
              className={styles.primaryButton}
            >
              Start Free Trial
            </button>
            <button
              onClick={() => document.getElementById('GoToClasses')?.scrollIntoView({ behavior: 'smooth' })}
              className={styles.secondaryButton}
            >
              Explore Classes
            </button>
          </motion.div>
        </motion.div>

        {/* Right Side: Animated Hero Graphic */}
        <motion.div
          className={styles.heroGraphicSection}
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <motion.div className={styles.imageWrapper} variants={imageVariants}>
            <div className={styles.glassCard}>
              <div className={styles.statsRow}>
                <div className={styles.statBox}>
                  <strong>50+</strong>
                  <span>Classes/Week</span>
                </div>
                <div className={styles.statBox}>
                  <strong>4.9★</strong>
                  <span>Member Rating</span>
                </div>
              </div>
            </div>
            <img src={img} alt="Yoga Studio" className={styles.heroImage} />

            {/* Decorative Floating Elements to simulate 3D/Spline feel */}
            <motion.div
              className={styles.floatingShape1}
              animate={{ y: [0, -15, 0], rotate: [0, 5, 0] }}
              transition={{ repeat: Infinity, duration: 6, ease: "easeInOut" }}
            />
            <motion.div
              className={styles.floatingShape2}
              animate={{ y: [0, 20, 0], rotate: [0, -10, 0] }}
              transition={{ repeat: Infinity, duration: 8, ease: "easeInOut", delay: 1 }}
            />
          </motion.div>
        </motion.div>

      </div>
    </div>
  );
}

export default Intro;
